import { Link } from "react-router-dom";
import { Activity } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { formatDate, lazyPage } from "@vixio/ui";
import "./api";
import { fmtScore } from "./api";
import { TeamsPage, useOrgCycles, useRecentAlerts } from "./TeamsPage";
import { PublicSurveyPage } from "./PublicSurveyPage";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const TeamPage = lazyPage(() => import("./TeamPage"), "TeamPage");

function PulsoWidget() {
  const org = useOrg();
  const cycles = useOrgCycles(org.id).data ?? [];
  const alerts = useRecentAlerts(org.id, 30).data ?? [];
  const open = cycles.filter((c) => c.status === "open");
  const team = new Map(cycles.map((c) => [c.team_id, c.team_name]));
  return (
    <div className="vx-stack">
      <dl className="vx-dl">
        <dt>Ciclos em coleta</dt>
        <dd className="num">{open.length}</dd>
        <dt>Respostas nos abertos</dt>
        <dd className="num">
          {open.reduce((a, c) => a + c.response_count, 0)} de {open.reduce((a, c) => a + c.invited_count, 0)}
        </dd>
      </dl>
      {alerts.length ? (
        <ul className="vx-stack" style={{ gap: 6, margin: 0, padding: 0, listStyle: "none" }}>
          {alerts.slice(0, 4).map((a) => (
            <li key={a.id}>
              <Link to={`/diagnostico/pulso/${a.team_id}`}>{team.get(a.team_id) ?? "Equipe"}</Link>
              <span className="text-crit num"> caiu {fmtScore(a.drop)} pontos</span>
              <span className="muted num"> · {formatDate(a.created_at)}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="muted" style={{ margin: 0 }}>
          Nenhum alerta de queda nos últimos 30 dias.
        </p>
      )}
      <Link to="/diagnostico/pulso">Abrir Pulso de Clima</Link>
    </div>
  );
}

export default defineModuleUi({
  key: "pulso",
  title: "Pulso de Clima",
  domain: "diagnostics",
  icon: Activity,
  menu: [{ path: "/diagnostico/pulso", label: "Pulso de clima", minRole: "member", icon: Activity, order: 30, keywords: "clima equipe anônimo ciclo convite queda" }],
  routes: [
    { path: "/diagnostico/pulso", element: <TeamsPage />, minRole: "member" },
    { path: "/diagnostico/pulso/:id", element: <TeamPage />, minRole: "member" },
  ],
  // Página pública do convite (sem login): /pulso/<token>.
  publicRoutes: [{ path: "/pulso/:token", element: <PublicSurveyPage /> }],
  widgets: [{ key: "pulso.cycles", title: "Pulso de clima", minRole: "member", span: 1, order: 31, element: PulsoWidget }],
});
